import { stationsActions } from '../reducer';

export const resetSelectedStation = () => stationsActions.resetSelectedStation();
